import WOC_2025 from "../../images/events/winter-of-code/winter-of-code-7-2025.png";
import WOC_2024 from "../../images/events/winter-of-code/winter-of-code-6-2024.jpg";
import WOC_2023 from "../../images/events/winter-of-code/winter-of-code-5-2023.png";
import WOC_2022 from "../../images/events/winter-of-code/winter-of-code-4-2022.png";
import WOC_2021 from "../../images/events/winter-of-code/winter-of-code-3-2021.png";
import WOC_2020 from "../../images/events/winter-of-code/winter-of-code-2-2020.png";
import WOC_2019 from "../../images/events/winter-of-code/winter-of-code-1-2019.png";

// WOC 7.0
import WOC7_REACT_IMG from "../../images/events/winter-of-code/winter-of-code-7/React-js.png";
import WOC7_SYSTEM_PROGRAMMING_IMG from "../../images/events/winter-of-code/winter-of-code-7/System-programming.png";
import WOC7_FLUTTER_IMG from "../../images/events/winter-of-code/winter-of-code-7/Flutter_1.png";
import WOC7_NODE_IMG from "../../images/events/winter-of-code/winter-of-code-7/node.png";
import WOC7_HTML_CSS_JS_IMG from "../../images/events/winter-of-code/winter-of-code-7/HTML-CSS-JS.png";
import WOC7_PYTHON_GUI_IMG from "../../images/events/winter-of-code/winter-of-code-7/Python-GUI.png";
import WOC7_SPRING_BOOT_IMG from "../../images/events/winter-of-code/winter-of-code-7/Spring-boot.png";
import WOC7_NLP_IMG from "../../images/events/winter-of-code/winter-of-code-7/NLP.png";
import WOC7_DJANGO_IMG from "../../images/events/winter-of-code/winter-of-code-7/Django.png";

// PDF
import WOC7_REACT_PDF from "../../documents/winter-of-code/winter-of-code-7/react-js.pdf";
import WOC7_NODE_PDF from "../../documents/winter-of-code/winter-of-code-7/node-js.pdf";
import WOC7_DJANGO_PDF from "../../documents/winter-of-code/winter-of-code-7/django.pdf";
import WOC7_SPRINGBOOT_PDF from "../../documents/winter-of-code/winter-of-code-7/spring-boot.pdf";
import WOC7_NLP_PDF from "../../documents/winter-of-code/winter-of-code-7/NLP.pdf";
import WOC7_HTML_CSS_JS_PDF from "../../documents/winter-of-code/winter-of-code-7/html-css-js.pdf";
import WOC7_FLUTTER_PDF from "../../documents/winter-of-code/winter-of-code-7/flutter.pdf";
import WOC7_SYSTEM_PROGRAMMING_PDF from "../../documents/winter-of-code/winter-of-code-7/system-programming.pdf";
import WOC7_PYTHON_GUI_PDF from "../../documents/winter-of-code/winter-of-code-7/python-gui.pdf";

export const WINTER_OF_CODE = [
    {
      image: WOC_2025,
      title: "WoC 7.0",
      description: "MSTC conducted the seventh Winter of Code, offering a platform for developers to learn and build projects.",
      projects: [
        { name: "React JS: CodeRunner IDE", link: "https://youtu.be/lmpv9eBKAEY" },
        { name: "Node JS: Collaborative Platform For Students", link: "https://youtu.be/xXSIKkKapL8" },
        { name: "HTML-CSS-JS: Educational Portal", link: "https://youtu.be/4oWVqGdytEc" },
        { name: "Python GUI: Restaurant Billing System", link: "https://youtu.be/WysWXngprNo" },
        { name: "Flutter: BINGR: A Movie Streaming App", link: "https://youtu.be/1STM0Oaez5M" },
        { name: "Django: E-Commerce System", link: "https://youtu.be/XlDHfSC5F7A" },
        { name: "Spring Boot: Course Registration System", link: "https://youtu.be/YX-m8XPUmwE" },
        { name: "Systems Programming: Terminal Database", link: "https://youtu.be/lyQjiEZgqu0" },
        { name: "Natural Language Processing (NLP): Fake Review Detection", link: "https://youtu.be/lbkCA1Mjgl8" },
      ],
    },
    {
      image: WOC_2024,
      title: "WoC 6.0",
      description: "MSTC conducted the sixth Winter of Code, providing opportunities for learning and project-building.",
      projects: [
        { name: "React JS: IRCTC Clone", link: "https://www.youtube.com/watch?v=ywguc8STJzA" },
        { name: "HTML-CSS-JS: Jigsaw Puzzle", link: "https://www.youtube.com/watch?v=plumt08kKow" },
        { name: "Django: Disaster Management System", link: "https://www.youtube.com/watch?v=83gxH1jKFUo" },
        { name: "Node JS: Pictionary Game", link: "https://www.youtube.com/watch?v=l9tQvRFXzUc" },
        { name: "Python GUI: Flash Card App", link: "https://www.youtube.com/watch?v=2Ei1gMLyiuo" },
        { name: "Data Science: Image Classifier", link: "https://www.youtube.com/watch?v=U2gTekO-8dY" },
        { name: "Flutter: Stock Market App", link: "https://www.youtube.com/watch?v=D9oLm3Z19Ho" },
        { name: "Systems Programming: VCS", link: "https://www.youtube.com/watch?v=urVjdv8tXQI" },
      ],
    },
    {
      image: WOC_2023,
      title: "WoC 5.0",
      description: "MSTC conducted the fifth Winter of Code, promoting learning and project-building.",
      projects: [
        { name: "Android: Social Media App", link: "https://www.youtube.com/watch?v=o66EavXESuY" },
        { name: "React JS: Menu App", link: "#" },
        { name: "Node JS: Job Portal", link: "https://www.youtube.com/watch?v=F2PxkzZ3w0U" },
        { name: "ML: Weather Prediction", link: "https://www.youtube.com/watch?v=C2gavMLvh5U" },
        { name: "Django: Interview Blog", link: "https://www.youtube.com/watch?v=HRouqDsGSko" },
        { name: "Python: MS Word Clone", link: "https://www.youtube.com/watch?v=JpZd26SXmhE" },
        { name: "UI/UX Prototyping", link: "https://www.youtube.com/watch?v=zkqZBjeXORk" },
      ],
    },
    {
      image: WOC_2022,
      title: "WoC 4.0",
      description: "MSTC conducted the fourth Winter of Code, enabling learning and project-building with mentor guidance.",
      projects: [
        { name: "Android: News App", link: "https://www.youtube.com/watch?v=-8dIE2snDfI" },
        { name: "React JS: Bingewatcher's Twitter", link: "https://www.youtube.com/watch?v=E9GuRpG2nbk" },
        { name: "Node JS: Blog Web App", link: "https://www.youtube.com/watch?v=nGKhXGWZU98" },
        { name: "ML: Sentiment Analysis", link: "#" },
        { name: "Django: Event Manager", link: "https://www.youtube.com/watch?v=vByCWm1K1II" },
        { name: "HTML-JS: Notes App", link: "https://www.youtube.com/watch?v=AWjL5w0LXI8" },
        { name: "Python: Image Editor", link: "https://www.youtube.com/watch?v=repT0HxIy1c" },
        { name: "UI/UX Prototyping", link: "https://www.youtube.com/watch?v=wfO51EMVIAs" },
      ],
    },
    {
      image: WOC_2021,
      title: "WoC 3.0",
      description: "MSTC conducted the third Winter of Code, enabling participants to learn and build projects with mentor guidance.",
      projects: [
        { name: "Android: Chat App", link: "#" },
        { name: "Django: Event Manager", link: "#" },
        { name: "JS: Keypress Visualizer", link: "#" },
        { name: "Web-Scraping: Price Tracker", link: "#" },
        { name: "Python: RPG Discord Bot", link: "#" },
        { name: "UI/UX Prototyping", link: "#" },
      ],
    },
    {
      image: WOC_2020,
      title: "WoC 2.0",
      description: "MSTC conducted the second Winter of Code, offering opportunities for learning and project-building.",
      projects: [
        { name: "Android: Password Manager", link: "https://www.youtube.com/watch?v=68s-JSHttWs" },
        { name: "Android: Movie Search App", link: "https://www.youtube.com/watch?v=Qlws6AUoFwQ" },
        { name: "JS: Quiz Game", link: "https://www.youtube.com/watch?v=ouzVMpoc7u4" },
        { name: "Data Science: App Profiles", link: "https://www.youtube.com/watch?v=O8mhUHw-w_I" },
        { name: "Django: Visitor Management", link: "https://www.youtube.com/watch?v=6jDfbqYkW3o" },
        { name: "Python: To-Do List App", link: "https://www.youtube.com/watch?v=x46yIyco7EQ" },
      ],
    },
    {
      image: WOC_2019,
      title: "WoC 1.0",
      description: "MSTC conducted the first Winter of Code, promoting learning and project-building.",
      projects: [
        { name: "Android: Password Manager", link: "#" },
        { name: "Game Dev: Ping Pong", link: "#" },
        { name: "JS: Quiz Game", link: "#" },
        { name: "Django: URL Shortener", link: "#" },
        { name: "Web-Scraping: Price Tracker", link: "#" },
        { name: "Python: To-Do App", link: "#" },
        { name: "HTML-JS: Responsive Website", link: "#" },
      ],
    },
  ];
  

export const WINTER_OF_CODE_7 = [
  {
    image: WOC7_REACT_IMG,
    category: "React JS",
    title: "Code Runner IDE",
    document: { name: "WoC-7-React-JS", path: WOC7_REACT_PDF },
    mentors: [{ name: "Zeelkumar Dadhaniya" }, { name: "Aayush Goyal" }, { name: "Manoj Dhundhalva" }, { name: "Jeet Patel" }],
    description: `CodeBoard - an online IDE This Online IDE project is a powerful, real-time development environment aimed at both educational and professional users. Built with React, it supports multiple programming languages, version control, and advanced text editor features like syntax highlighting, auto-indentation, and bracket matching. It includes secure Firebase-based authentication with guest and user modes. Authenticated users can save, edit, and download code files. The platform also features state management via Redux, resizable and movable elements, and an AI chatbot for coding assistance. Participants will learn React development, API integration, and serverless architecture while creating this scalable and feature-rich application.`,
    whatsapp_link: "https://chat.whatsapp.com/L11jrNjwRI33sVrJgSLHgo",
    youtube_link: "https://youtu.be/lmpv9eBKAEY",
  },
  {
    image: WOC7_NODE_IMG,
    category: "Node JS",
    title: "Collaborative Platform For Students",
    document: { name: "WoC-7-Node-JS", path: WOC7_NODE_PDF },
    mentors: [{ name: "Brinda Sorathiya" }, { name: "Nidhi Dodiya" }, { name: "Devang Vaghani" }],
    description: `aDApt is a student-focused collaborative platform with features like authenticated login/signup (user and admin accounts), a QnA chatroom for category-wise questions and solutions (with image support), a shared resource library for course materials, and a categorized list of important email IDs and websites. It also includes a Lost & Found section for managing items, with a "found" tag to resolve entries. Users can upload profile pictures and edit their profiles for a personalized experience.`,
    whatsapp_link: "https://chat.whatsapp.com/BO2l5THAUQGIX4yXdgLOO1",
    youtube_link: "https://youtu.be/xXSIKkKapL8",
  },
  {
    image: WOC7_HTML_CSS_JS_IMG,
    category: "HTML CSS JS",
    title: "Educational Portal",
    document: { name: "WoC-7-HTML-CSS-JS", path: WOC7_HTML_CSS_JS_PDF },
    mentors: [{ name: "Aarya Shah" }, { name: "Manoj Dhundhalva" }, { name: "Devang Vaghani" }, { name: "Ramya Shah" }, { name: "Shruti Choudhary" }],
    description: `The education portal is a comprehensive web application built using HTML, CSS, and JavaScript. It features secure login and signup authentication to ensure user access control. The platform offers various courses, which users can enroll in to unlock video content. An interactive chatbot, developed with JavaScript, is integrated to assist users with queries and enhance their learning experience.`,
    whatsapp_link: "https://chat.whatsapp.com/KTmfdVlRtTa5apFEsCwwoF",
    youtube_link: "https://youtu.be/4oWVqGdytEc",
  },
  {
    image: WOC7_PYTHON_GUI_IMG,
    category: "Python GUI",
    title: "Restaurant Billing System",
    document: { name: "WoC-7-Python-GUI", path: WOC7_PYTHON_GUI_PDF },
    mentors: [{ name: "Vrund Hemang Kansara" }, { name: "Swayam Hingu" }],
    description: `The Restaurant Management System is a versatile desktop application designed to handle billing, inventory, and menu management for multiple restaurants. It enables seamless operations with features like real-time billing, inventory tracking, menu customization, and multi-restaurant support. Users can manage food items, monitor stock levels, and generate detailed receipts, all through an intuitive interface. Built using Python and PyQt5, this project provides a hands-on experience in creating efficient and user-friendly GUI applications tailored to meet the diverse needs of restaurant management.`,
    whatsapp_link: "https://chat.whatsapp.com/C2SFOAfw34fCrf9pyRXouM",
    youtube_link: "https://youtu.be/WysWXngprNo",
  },
  {
    image: WOC7_FLUTTER_IMG,
    category: "Flutter",
    title: "BINGR: A Movie Streaming App",
    document: { name: "WoC-7-Flutter", path: WOC7_FLUTTER_PDF },
    mentors: [{ name: "Dhyey Parekh" }, { name: "Tanmay Singh" }, { name: "Parjanya Rajput" }],
    description: `Bingr is a modern OTT app designed to elevate your movie and series exploration. Stay updated with the latest, trending, and popular titles in real-time. Key features include categorized browsing, detailed insights (cast, ratings, box office), and personalized options like Wishlist and in-app trailer viewing. A powerful text and voice search, secure Firebase Authentication, and a sleek, user-friendly interface enhance your experience. Cross-platform availability and regular updates make Bingr the ultimate entertainment companion for discovering and organizing your favorite content.`,
    whatsapp_link: "https://chat.whatsapp.com/Dy7je7xlZCV0jgH1kYQUUZ",
    youtube_link: "https://youtu.be/1STM0Oaez5M",
  },
  {
    image: WOC7_SPRING_BOOT_IMG,
    category: "Spring Boot",
    title: "Course Registration System",
    document: { name: "WoC-7-Spring-Boot", path: WOC7_SPRINGBOOT_PDF },
    mentors: [{ name: "Chinmai Kewlani" }, { name: "Riddhi Mistry" }, { name: "Parjanya Rajput" }],
    description: `The Course Registration System is a Spring Boot project designed to manage course allocation for students with ease. It has three main roles: Admin, Student, and Professor. The Admin can manage courses, add students and professors, allocate courses, and send email notifications. Professors and students can view their assigned courses and update their details. The system uses PostgreSQL as the database for storing all application data securely. It employs JWT tokens for secure login and role-based access. It also includes Swagger to test and document all APIs, making it simple and efficient to use.`,
    whatsapp_link: "https://chat.whatsapp.com/FBByNjBKuEdDjDIL15D54N",
    youtube_link: "https://youtu.be/YX-m8XPUmwE",
  },
  {
    image: WOC7_SYSTEM_PROGRAMMING_IMG,
    category: "Systems Programming",
    title: "Terminal Database",
    document: { name: "WoC-7-Systems-Programming", path: WOC7_SYSTEM_PROGRAMMING_PDF },
    mentors: [{ name: "Rudra Desai" }, { name: "Swayam Hingu" }],
    description: `The Terminal-Based Key-Value Database is a system programming project designed to teach core database and networking concepts. It involves building a robust key-value database with features like CRUD operations, namespaces, indexing, periodic backups, transaction support, and a server-client architecture for real-time, multi-client interactions. Participants gain hands-on experience with file I/O, socket programming, and data serialization while implementing a scalable, self-managed database system from scratch.`,
    whatsapp_link: "https://chat.whatsapp.com/JHQ4FExbqtN4MNt48615jX",
    youtube_link: "https://youtu.be/lyQjiEZgqu0",
  },
  {
    image: WOC7_NLP_IMG,
    category: "Natural Language Processing (NLP)",
    title: "Fake Review Detection",
    document: { name: "WoC-7-Natural-Language-Processing-(NLP)", path: WOC7_NLP_PDF },
    mentors: [{ name: "Vashisht Purani" }, { name: "Malhar Prajapati" }, { name: "Venil Vekariya" }],
    description: `Fake Review Detection - The Amazon Fake Review Detection System leverages Natural Language Processing (NLP) techniques to identify fraudulent or computer-generated reviews. By analyzing text patterns and linguistic features, the system detects fake reviews and flags them as "Critical." This project aims to enhance trust in online marketplaces by ensuring users rely on genuine feedback for informed purchasing decisions. It demonstrates the power of NLP in combating digital misinformation.`,
    whatsapp_link: "https://chat.whatsapp.com/GYJVLaC8wi18Hc4kr4uKJy",
    youtube_link: "https://youtu.be/lbkCA1Mjgl8",
  },
  {
    image: WOC7_DJANGO_IMG,
    category: "Django",
    title: "E-Commerce System",
    document: { name: "WoC-7-Django", path: WOC7_DJANGO_PDF },
    mentors: [{ name: "Ka. Patel Priyanshi Prafulbhai" }, { name: "Kaival Mehta" }, { name: "Venil Vekariya" }],
    description: `The Ecommerce Store project made using Django is aimed to teach and practice web development concepts. The site includes features like product listings, user authentication, a shopping cart, and order management. It provides a hands-on opportunity to understand backend frameworks, database integration, and dynamic content rendering. This project aims to strengthen foundational knowledge in building scalable and functional web applications.`,
    whatsapp_link: "https://chat.whatsapp.com/CawWaXdswqpANyamXa3mP1",
    youtube_link: "https://youtu.be/XlDHfSC5F7A",
  }
];